class Group {
    constructor(data) {
      this.Id = data.Id;
      this.ExternalId = data.ExternalId;
      this.Name = data.Name;
    }
  }
  
  export default Group;
  